import { render, staticRenderFns } from "./appBlockCompany.vue?vue&type=template&id=2fbb2125&scoped=true"
import script from "./appBlockCompany.vue?vue&type=script&lang=js"
export * from "./appBlockCompany.vue?vue&type=script&lang=js"
import style0 from "./appBlockCompany.vue?vue&type=style&index=0&id=2fbb2125&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbb2125",
  null
  
)

export default component.exports